import {Component, Input, OnInit} from '@angular/core';
import {AbstractComponent} from "@components";
import {
  ApplicationFormSettings, CategoryItem,
  Competitor, CompetitorFilter, CompetitorResults,
  CompetitorStatus, Country, DEFAULT_PAGE_INDEX,
  EventItem, FetchEventByIdRequest,
  Lookups,
  PagedFilter,
  Pages, Race, RaceRegistration, RaceSettings, Waypoint
} from "@model";
import {CompetitorResultsService, EventService, ExportService} from "@services";
import {
  REGISTER_TO_RACE
} from "../../../../../../app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-event-management',
  templateUrl: './event-management.component.html',
  styleUrls: ['./event-management.component.scss']
})
export class EventManagementComponent extends AbstractComponent implements OnInit {
  @Input() waypointList: Waypoint[] = [];
  @Input() eventItem: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];
  @Input() competitors: Competitor[] = [];
  @Input() raceRegistrations: RaceRegistration[] = [];
  @Input() genders: Lookups[] = [];
  categories: CategoryItem[] = [];
  results: CompetitorResults[] = [];

  filter: PagedFilter<CompetitorFilter> | undefined;
  raceRegistrationsPage: number = DEFAULT_PAGE_INDEX;
  hasMoreRaceRegistrations: boolean = false;
  name: string | undefined;
  organiserId: number | undefined;
  disableRegisterToRace: boolean = false;
  category: number | undefined = undefined;
  gender: number | undefined = undefined;
  page: number = 1;
  selectedStatus: CompetitorStatus | undefined;
  applicationFromSettingsList: ApplicationFormSettings[] = [];
  settingsList: RaceSettings[] = [];

  searchForm: FormGroup<{ name: FormControl<any>; status: FormControl<any> }> = new FormGroup({
    name: new FormControl(),
    status: new FormControl(),
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private exportService: ExportService,
    private eventService: EventService,
    private competitorResultsService: CompetitorResultsService,
  ) {
    super();
  }

  ngOnInit() {
    this.findResultsForFirstRace();
    this.findCategoriesForFirstRace();
    this.applicationFromSettingsList = (this.eventItem?.racesList?.flatMap(item=>item.applicationFormSettings) ?? []).filter((item): item is ApplicationFormSettings =>!!item);
    this.settingsList = (this.eventItem?.racesList?.flatMap(item=>item.raceSettings) ?? []).filter((item): item is RaceSettings =>!!item);
    this.subscribeToFilterChange();
    this.disableRegisterToRace = this.isDisableRegisterToRace();
  }

  findResultsForFirstRace() {
    let competitorFilter: CompetitorFilter = new CompetitorFilter();
    competitorFilter.raceId = this.eventItem!.racesList![0].id;
    competitorFilter.eventId = this.eventItem!.id;
    this.competitorResultsService.getCompetitorResults(new PagedFilter(new Pages(), competitorFilter), true).subscribe(results => {
      this.results = results;
    });
  }

  findCategoriesForFirstRace() {
    this.competitorResultsService.findCategoryItemsByRaceId(this.eventItem!.racesList![0].id!).subscribe(categories => {
      this.categories = categories;
    });
  }

  private subscribeToFilterChange(): void {
    this.subscriptions.push(this.searchForm.valueChanges.subscribe(_ => {
        this.name = this.searchForm.controls.name.value;
        this.selectedStatus = this.searchForm.controls.status.value;
      }
    ));
  }

  registerToRace() {
    const openForRegistration: Race[] = this.eventItem?.racesList?.filter(r => !!r.organiserOpen) || [];

    if (openForRegistration.length > 0) {
      this.router.navigate([REGISTER_TO_RACE], {
        relativeTo: this.route,
        queryParams: {
          eventId: this.eventItem!.id,
          raceId: openForRegistration[0].id
        }
      });
    }
  }

  downloadStartList() {
    this.exportService.downloadStartList(this.eventItem!.id!);
  }

  downloadListOfRaces(type: string) {
    this.exportService.downloadListOfRaces(type, +this.route.snapshot.queryParams['eventId']);
  }

  isDisableRegisterToRace() {
    let disableRegisterToRace: boolean = true;
    if ((this.eventItem?.racesList?.length ?? 0) > 0) {
      for (var race of this.eventItem?.racesList!) {
        if (race.organiserOpen) {
          disableRegisterToRace = false;
          break;
        }
      }
    }
    return disableRegisterToRace;
  }

  downloadCompetitorsListForEvent(type: string, filter: PagedFilter<CompetitorFilter> | undefined) {
    if (filter === undefined || filter === null) {
      let filterNull: CompetitorFilter = new CompetitorFilter();
      filterNull.eventId = +this.route.snapshot.queryParams['eventId'];
      this.filter = new PagedFilter(new Pages(undefined, 1), filterNull);
      filter = this.filter;
    }
    this.exportService.downloadCompetitorsListForEvent(type, filter);
  }

  onRefreshCounters() {
    this.eventService.findEventByIdProtected(new FetchEventByIdRequest(this.eventItem!.id!), false, true).subscribe(eventItem => {
      this.eventItem = eventItem ?? this.eventItem;
    })
  }

  downloadRaceRegistrationQRCode() {
    this.exportService.downloadRaceRegistrationQRCode(this.eventItem!.name, this.eventItem!.id);
  }


  protected readonly RaceRegistration = RaceRegistration;
}
